module.exports = __webpack_public_path__ + "img/yoga-mat.51c16b54.jpg";